<div class="container app-content-body">
    <div class="row">
        <div class="col-10">
            <h5 class="text-uppercase font-weight-bold app-text-accent">{{'terms-and-conditions.title' | translate}}</h5>
        </div>
        <div class="col-2">
            <div class="form-group">
                <select [(ngModel)]="language" name="selectedLanguage" id="selectedLanguage" class="p-dropdown" (change)="onChangeLanguage($event)">
                  <option [value]="item.id" *ngFor="let item of languages">{{item.text}}</option>
                </select>  
              </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p>{{'terms-and-conditions.p1' | translate}}</p>
            <p>{{'terms-and-conditions.p2' | translate}}</p>
            <p>{{'terms-and-conditions.p3' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'terms-and-conditions.use-of-content' | translate}}</h6>
            <p>{{'terms-and-conditions.use-of-content-p1' | translate}}</p>
            <p>{{'terms-and-conditions.use-of-content-p2' | translate}}</p>
            <p>{{'terms-and-conditions.use-of-content-p3' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'terms-and-conditions.access-control' | translate}}</h6>
            <p>{{'terms-and-conditions.access-control-p1' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'terms-and-conditions.termination' | translate}}</h6>
            <p>{{'terms-and-conditions.termination-p1' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'terms-and-conditions.election-of-law-and-jurisdiction' | translate}}</h6>
            <p>{{'terms-and-conditions.election-of-law-and-jurisdiction-p1' | translate}}</p>
            <p>{{'terms-and-conditions.election-of-law-and-jurisdiction-p2' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'terms-and-conditions.responsibility-of-blueassist-its-afiliates-and-licensors' | translate}}</h6>
            <p>{{'terms-and-conditions.responsibility-of-blueassist-its-afiliates-and-licensors-p1' | translate}}</p>
            <p>{{'terms-and-conditions.responsibility-of-blueassist-its-afiliates-and-licensors-p2' | translate}}</p>
            <p>{{'terms-and-conditions.responsibility-of-blueassist-its-afiliates-and-licensors-p3' | translate}}</p>
            <p>{{'terms-and-conditions.responsibility-of-blueassist-its-afiliates-and-licensors-p4' | translate}}</p>
            <p>{{'terms-and-conditions.responsibility-of-blueassist-its-afiliates-and-licensors-p5' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'terms-and-conditions.indemnization' | translate}}</h6>
            <p>{{'terms-and-conditions.indemnization-p1' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'terms-and-conditions.external-links' | translate}}</h6>
            <p>{{'terms-and-conditions.external-links-p1' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'terms-and-conditions.questions' | translate}}</h6>
            <p>{{'terms-and-conditions.questions-p1' | translate}}</p>
            <p>{{'terms-and-conditions.questions-p2' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'terms-and-conditions.effective-date' | translate}}</h6>
            <p>{{'terms-and-conditions.effective-date-p1' | translate}}</p>
            <p>{{'terms-and-conditions.effective-date-p2' | translate}}</p>
        </div>
    </div>
</div>
